const convertStatusProgress = (tableView) => {
  if (tableView === 'requested') return [{ label: 'Diproses' }];
  else return [{ label: 'Diterima' }, { label: 'Ditolak' }];
};

export default convertStatusProgress;
